export const FLUXO_TIPO_TODOS = 0;
export const FLUXO_TIPO_CENTRALIZADO = 1;
export const FLUXO_TIPO_DESCENTRALIZADO = 2;

export const allFluxoVersoes = [
  FLUXO_TIPO_TODOS,
  FLUXO_TIPO_CENTRALIZADO,
  FLUXO_TIPO_DESCENTRALIZADO,
];

export const FLUXO_TIPO_TODOS_NAME = 'todos';
export const FLUXO_TIPO_CENTRALIZADO_NAME = 'centralizado';
export const FLUXO_TIPO_DESCENTRALIZADO_NAME = 'descentralizado';

export const allFluxoTipoNomes = [
  FLUXO_TIPO_TODOS_NAME,
  FLUXO_TIPO_CENTRALIZADO_NAME,
  FLUXO_TIPO_DESCENTRALIZADO_NAME,
];

export const CONTRATO_TIPO_TODOS = 0;
export const CONTRATO_TIPO_ASSESSOR = 1;
export const CONTRATO_TIPO_ENTE_PUBLICO = 2;
export const CONTRATO_TIPO_ENTE_PRIVADO = 3;
export const CONTRATO_TIPO_ENTE_PRIVADO_REDE = 4;

export const allContratoVersoes = [
  CONTRATO_TIPO_TODOS,
  CONTRATO_TIPO_ASSESSOR,
  CONTRATO_TIPO_ENTE_PUBLICO,
  CONTRATO_TIPO_ENTE_PRIVADO,
  CONTRATO_TIPO_ENTE_PRIVADO_REDE,
];

export const CONTRATO_TIPO_TODOS_NAME = 'todos';
export const CONTRATO_TIPO_ASSESSOR_NAME = 'assessor';
export const CONTRATO_TIPO_ENTE_PUBLICO_NAME = 'ente-publico';
export const CONTRATO_TIPO_ENTE_PRIVADO_NAME = 'ente-privado';
export const CONTRATO_TIPO_ENTE_PRIVADO_REDE_NAME = 'ente-privado-rede';

export const CONTRATO_TIPO_ASSESSOR_DESCENTRALIZADO_NAME =
  'assessor-descentralizado';
export const CONTRATO_TIPO_ENTE_PUBLICO_DESCENTRALIZADO_NAME =
  'ente-publico-descentralizado';
export const CONTRATO_TIPO_ENTE_PRIVADO_DESCENTRALIZADO_NAME =
  'ente-privado-descentralizado';

export const allContratoTipoNomes = [
  CONTRATO_TIPO_TODOS_NAME,
  CONTRATO_TIPO_ASSESSOR_NAME,
  CONTRATO_TIPO_ENTE_PUBLICO_NAME,
  CONTRATO_TIPO_ENTE_PRIVADO_NAME,
  CONTRATO_TIPO_ASSESSOR_DESCENTRALIZADO_NAME,
  CONTRATO_TIPO_ENTE_PUBLICO_DESCENTRALIZADO_NAME,
  CONTRATO_TIPO_ENTE_PRIVADO_DESCENTRALIZADO_NAME,
];
